module.exports = __webpack_public_path__ + "img/delivery.aaffb3dc.jpg";